<template>
  <v-card>
    <v-card-title primary-title>
      <h3 class="headline">Edit channels</h3>
    </v-card-title>
    <v-card-text>

      <div v-if="alerts.length > 0">
        <v-alert type="error" :value="true">
          <h4>{{ alert.title }}</h4>
          {{ alert.description }}
        </v-alert>
      </div>

      <v-layout v-if="alerts.length == 0 && channelsStruct.length > 1">
        <v-flex md3>
          <v-checkbox v-model="linkedFields" label="Linked fields"></v-checkbox>
        </v-flex>
        <v-flex md3 class="pt-3">
          <v-menu v-if="linkedFields" slot="append" offset-x open-on-hover>
            <v-icon slot="activator" color="warning">warning</v-icon>
            <v-alert type="warning" :value="true">
              <h4>Linked fields option is active</h4>
                Fields accross channels are linked together.<br>
                Modifying a field on one channel, applies the value to the others.<br>
                Use with caution.
            </v-alert>
          </v-menu>
        </v-flex>
      </v-layout>

      <v-tabs v-if="alerts.length == 0" v-model="activeTab">
        <v-tab>Global parameters</v-tab>
        <v-tab>Devices</v-tab>
        <v-tab v-for="(sch, i) in channelsStruct" :key="i">Channel #{{ i + 1 }}</v-tab>
        <v-tab-item>
          <form-schema ref="global" v-model="formValues" :schema="schema" :no-submit="true"></form-schema>
        </v-tab-item>
        <v-tab-item>
          <form-schema ref="device" @input="handleDeviceFormInput" :value="deviceValues" :schema="devicesSchema" :no-submit="true" :disabled="channelValues.length > 0"></form-schema>
          <v-layout v-if="channelsStruct.length == 0">
            <v-btn @click="handleCreateSingle">Create a single channel</v-btn>
            <v-btn @click="handleCreateTriplet">Create a triplet</v-btn>
          </v-layout>
        </v-tab-item>
        <v-tab-item v-for="(sch, i) in channelsStruct" :key="i">
          <form-schema ref="channelForm" @input="$set(channelValues, i, $event)" :value="channelValues[i]" :schema="channelsStruct[i]" :no-submit="true"></form-schema>
        </v-tab-item>
      </v-tabs>

    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="handleSubmit" color="primary" :disabled="channelsStruct.length == 0">Submit</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import utils from './../utils'
import configChannelSchema from './../schema/configChannel.json'

const DEVICES = [
  'sensor', 'analog_filter', 'digitizer', 'digital_filter'
]

let sortByValue = (a, b) => {
  a = a.value
  b = b.value
  return a == b ? 0 : a < b ? -1 : 1
}

export default {

  props: ['schema', 'devicesSchema', 'deviceInventory', 'softwareFilters', 'value'],

  data () {
    return {
      alerts: [],
      formValues: {},
      deviceValues: {},
      channelValues: [],
      deviceSerialOpt: {},
      channelsStruct: [],
      lastStateChannels: [],
      savedChannelValues: null,
      linkedFields: false,
      activeTab: 0
    }
  },

  mounted () {
    this.initValues()
  },

  watch: {
    channelValues: 'linkChannels'
  },

  methods: {

    initValues () {
      configChannelSchema.properties.software_filter.enum = this.softwareFilters.map(
        x => ({ key: x, label: x })
      )
      this.checkSchema()
      if (this.value && this.value.channel != null) {
        let values = utils.cloneObject(this.value)
        this.deviceValues = values.device
        for (let [index, ch] of values.channel.entries()) {
          this.createChannelByIndex(index)
          Object.assign(this.lastStateChannels[index], ch)
          Object.assign(this.channelValues[index], ch)
        }
        this.linkedFields = values.channel.length == 3
        delete values.device
        delete values.channel
        this.$set(this, 'formValues', values)
      }
    },

    getPath (obj, path, defaultValue) {
      let prev = obj
      for (let [i, k] of path.entries()) {
        if (prev[k] == null) {
          prev = prev[k] = i < (path.length - 1) ? {} : defaultValue
        } else {
          prev = prev[k]
        }
      }
      return prev
    },

    /*updateChannelsWithNewChain () {
      // console.log('updateChannelsWithNewChain');
      this.linkedFields = false
      if (this.savedChannelValues == null) {
        this.savedChannelValues = this.channelValues.map(x => Object.assign({}, x))
      }
      this.channelsStruct = []
      this.channelValues = []
      this.lastStateChannels = []
      for (let [index, ch] of this.savedChannelValues.entries()) {
        this.createChannelByIndex(index)
        for (let [k, v] of Object.entries(this.channelsStruct[index].properties)) {
          // console.log(k, v);
          if (DEVICES.indexOf(k) >= 0) {
            if (['analog_filter', 'digital_filter'].indexOf(k) >= 0) {
              // process list of analog_filter or digital_filter
              for (let [i, item] of Object.entries(v.properties)) {
                // console.log(i, item);
                for (let [propKey, propObj] of Object.entries(item.properties)) {
                  let propValue = this.getPath(ch, [k, i, propKey], null)
                  // console.log(propKey, propObj, propValue);
                  if (propValue != null) {
                    if (propObj.enum.find(x => x.key == propValue) != null) {
                      // assign the previous value if it can be found in options
                      this.channelValues[index][k][i][propKey] = propValue
                    }
                  }
                }
              }
            } else {
              // process other devices
              for (let [propKey, propObj] of Object.entries(v.properties)) {
                let propValue = this.getPath(ch, [k, propKey], null)
                // console.log(propKey, propObj, propValue);
                if (propValue != null) {
                  if (propKey.indexOf('digital_filter') >= 0 && propValue != null) {
                    let model = this.deviceValues[k][1]
                    // try to keep same sampling frequency when the digitizer changes
                    let sf = this.getDigitizerSamplingFrequency(model, propValue)
                    let match_sf = propObj.enum.find(x => x.value == sf.value)
                    if (match_sf != null) {
                      this.channelValues[index][k][propKey] = match_sf.key
                    }
                  } else if (propObj.enum.find(x => x.key == propValue) != null) {
                    // assign the previous value if it can be found in options
                    this.channelValues[index][k][propKey] = propValue
                  }
                }
              }
            }
          } else {
            // keep same value if the current key is not device dependent
            this.channelValues[index][k] = ch[k]
          }
        }
      }
      this.linkedFields = this.channelValues.length == 3
    },*/

    getDeviceData (dev, manufacturer, model) {
      return this.deviceInventory[dev].children
        .find(x => x.value == manufacturer).children
        .find(x => x.value == model).data
    },

    linkChannels (newValue, oldValue) {
      if (this.linkedFields) {
        let compIndex = ['Z', 'N', 'E']
        function recursiveCheck(obj, refObj, changes) {
          // console.log(obj, refObj)
          for (let [k, v] of Object.entries(obj)) {
            // console.log(k, v);
            if (v instanceof Object) {
              if (changes[k] == null) {
                changes[k] = {}
              }
              // Object.assign(changes[k], recursiveCheck(v, refObj[k], {}))
              recursiveCheck(v, refObj[k], changes[k])
            } else if (
              k.indexOf('component') < 0 &&
              v != refObj[k] &&
              changes[k] == null
            ) {
              changes[k] = v
            }
          }
          return changes
        }
        function recursiveUpdate(index, obj, changes) {
          let newObj = Object.assign({}, obj)
          for (let [k, v] of Object.entries(changes)) {
            if (v instanceof Object) {
              newObj[k] = recursiveUpdate(index, obj[k], v)
            } else {
              let value = v
              if (k == 'iris_code') {
                if (v != null && v.length > 1) {
                  value = v.slice(0, 2)+compIndex[index]
                }
              }
              newObj[k] = value
            }
          }
          return newObj
        }
        let changes = {}
        // console.log(newValue, this.lastStateChannels);
        for (let [i, newCha] of newValue.entries()) {
          recursiveCheck(newCha, this.lastStateChannels[i], changes)
        }
        // console.log(changes);
        for (let [i, newCha] of newValue.entries()) {
          newValue[i] = recursiveUpdate(i, newCha, changes)
        }

        this.lastStateChannels = this.channelValues.map(x => utils.cloneObject(x))
      }
    },

    checkSchema () {
      let schProp = this.schema.properties
      if (schProp.network.enum.length == 0) {
        this.alerts.push({
          title: 'No network.',
          description:'You must create an instance of Network before create a Channel.'
        })
      }
      if (schProp.location.enum.length == 0) {
        this.alerts.push({
          title: 'No location.',
          description: 'You must create an instance of Location before create a Channel.'
        })
      }
    },

    guessComponentByIndex (index, compList) {
      let compIndex = [
        ['Z', 'Z', '1'],
        ['N', 'Y', '2'],
        ['E', 'X', '3']
      ]
      for (let c of compIndex[index]) {
        let result = compList.find(x => {
          let comp = x.indexOf('-') >= 0 ? x.split('-')[1] : x
          return comp.indexOf(c) >= 0
        })
        if (result != null) {
          return result
        }
      }
      return ''
    },

    getDefault (index, devType, devProp, devPropValues) {
      if (devType == 'digital_filter') {
        return null
      }
      if (devProp.indexOf('component') >= 0) {
        if (devType == 'digitizer') {
          return devPropValues[index]
        } else {
          return this.guessComponentByIndex(index, devPropValues)
        }
      }/* else if (devProp.indexOf('digital_filter') < 0) {
        return devPropValues[0]
      }*/
      return null
    },

    processDeviceProperties (compIndex, devType, manufacturer, model, devProps) {
      let result = {}
      let devData = this.getDeviceData(devType, manufacturer, model)
      // console.log({compIndex, devType, manufacturer, model, devProps, devData})
      for (let [k, v] of Object.entries(devProps)) {
        let propValues = devType == 'digital_filter' ? devData.config : devData[k]
        if (propValues.length > 0) {
          propValues.sort()
          v.enum = propValues.map(x => ({ key: x, label: x }))
          result[k] = this.getDefault(compIndex, devType, k, propValues)

          if (k.indexOf('analog_filter') >= 0) {
            for (let o of v.enum) {
              o.label = o.label.gain
              o.key = o.key.name
            }
          } else if (k.indexOf('digital_filter') >= 0) {
            for (let o of v.enum) {
              o.key = o.key.name
              o.label = o.value = o.label.output_frequency
              // let sf = this.getDigitizerSamplingFrequency(model, o.key)
              // Object.assign(o, sf)
            }
            v.enum.sort(sortByValue)
          } else if (devType == 'digital_filter') {
            for (let o of v.enum) {
              o.key = o.label = o.key.name
            }
            v.enum.sort(sortByValue)
          }

        } else {
          delete devProps[k]
        }
      }
      return result
    },

    createChannelByIndex (index) {
      let dev = this.deviceValues
      let sch = utils.cloneObject(configChannelSchema)
      let chValues = {}

      for (let devType of Object.keys(this.deviceInventory)) {
        let devObj = dev[devType]
        if (['sensor', 'digitizer'].indexOf(devType) >= 0) {
          if (devObj != null) {

            chValues[devType] = this.processDeviceProperties(
              index, devType, dev[devType][0], dev[devType][1],
              sch.properties[devType].properties
            )

          } else {
            delete sch.properties[devType]
          }
        } else if (['analog_filter', 'digital_filter'].indexOf(devType) >= 0) {
          if (devObj.length > 0) {
            chValues[devType] = {}
            let devSch = utils.cloneObject(sch.properties[devType].properties['0'])

            for (let [i, devItem] of devObj.entries()) {
              sch.properties[devType].properties[i] = utils.cloneObject(devSch)
              sch.properties[devType].properties[i].title = devItem.join(' / ')

              chValues[devType][i] = this.processDeviceProperties(
                index, devType, devItem[0], devItem[1],
                sch.properties[devType].properties[i].properties
              )

            }

          } else {
            delete sch.properties[devType]
          }
        }
      }

      chValues.orientation = {
        dip: index == 0 ? -90 : 0,
        azimuth: index == 2 ? 90 : 0
      }
      this.lastStateChannels.push(Object.assign({}, chValues))
      // console.log(chValues, sch)
      this.channelValues.push(chValues)
      this.channelsStruct.push(sch)
    },

    getDigitizerSamplingFrequency (model, value) {
      let result = {}
      value = value.replace(`${model}-`, '')
      let sp_value = value.split('-')
      let extra = ''
      if (sp_value.length > 1) {
        extra = ` (${sp_value.slice(0, -1).join('-')})`
      }
      let raw_sf = value.split('-').slice(-1)[0]
      let m = raw_sf.match(/s([0-9]+)/)
      if (m) {
        result.label = m[1] == '1' ? '125/128' : `1/${m[1]}`
        result.value = m[1] == '1' ? 125/128 : 1/parseFloat(m[1])
      } else {
        result.label = raw_sf
        result.value = parseFloat(raw_sf)
      }
      result.label = `${result.label}${extra}`
      return result
    },

    validateDevices () {
      for (let i = this.deviceValues.analog_filter.length; i >= 0; --i) {
        if (this.deviceValues.analog_filter[i] == null) {
          this.deviceValues.analog_filter.splice(i, 1)
        }
      }
      for (let i = this.deviceValues.digital_filter.length; i >= 0; --i) {
        if (this.deviceValues.digital_filter[i] == null) {
          this.deviceValues.digital_filter.splice(i, 1)
        }
      }
      let s = this.deviceValues['sensor'] != null
      let d = this.deviceValues['digitizer'] != null
      let result = true
      if (!s || !d) {
        result = false
      }
      if (!result) {
        this.$notify({
          color: 'error',
          message: 'Invalid instrumental chain.'
        })
      }
      return result
    },

    handleCreateTriplet () {
      if (this.$refs.global.getForm().validate()) {
        this.linkedFields = true
        if (this.validateDevices()) {
          for (let i=0; i<3; i++) {
            this.createChannelByIndex(i)
          }
          setTimeout(() => {
            this.activeTab = 2
          }, 500)
        }
      } else {
        this.activeTab = 0
      }
    },

    handleCreateSingle () {
      if (this.$refs.global.getForm().validate()) {
        if (this.validateDevices()) {
          this.createChannelByIndex(0)
          setTimeout(() => {
            this.activeTab = 2
          }, 500)
        }
      } else {
        this.activeTab = 0
      }
    },

    checkSamplingFrequencyCascade () {
      let sch = this.channelsStruct[0].properties
      if (
        !(
          sch.digitizer && sch.digitizer.properties.digital_filter
        )
      ) {
        console.warn('No sampling frequency parameter found');
        return true
      }
      for (let [index, ch] of this.channelValues.entries()) {
        sch = this.channelsStruct[index].properties
        let sf_list;
        let sf_value;
        if (sch.digitizer && sch.digitizer.properties.digital_filter) {
          sf_value = ch.digitizer.digital_filter
          sf_list = sch.digitizer.properties.digital_filter.enum
        }
        if (sf_value == null) {
          return false
        }
        let sf = sf_list.find(x => x.key == sf_value).value
        if (ch.digital_filter != null) {
          for (let [i, df] of Object.entries(ch.digital_filter)) {
            let [sf_in, sf_out] = df.filter.split('-').map(parseFloat)
            if (sf_in != sf) {
              return false
            }
            sf = sf_out
          }
        }
        if (ch.software_filter != null && ch.software_filter != '') {
          let [sf_in, sf_out] = ch.software_filter.split('-').slice(1).map(parseFloat)
          if (sf_in != sf) {
            return false
          }
          sf = sf_out
        }
      }
      return true
    },

    handleSubmit () {
      if (!this.validateDevices()) {
        this.$notify({ color: 'error', message: 'Invalid devices value.' })
        this.activeTab = 1
        return
      }
      let isValid = true
      for (let [index, _] of this.channelsStruct.entries()) {
        let chForm = this.$refs['channelForm'][index]
        let valid = chForm.getForm().validate()
        if (!valid) {
          isValid = false
          this.$notify({ color: 'error', message: 'Error found in the form.' })
          this.activeTab = 2 + index
          break
        }
      }
      if (isValid) {
        if (this.checkSamplingFrequencyCascade()) {
          let result = Object.assign({
            device: this.deviceValues,
            channel: this.channelValues
          }, this.formValues)
          this.$emit('input', result)
          this.$emit('submit')
        } else {
          this.activeTab = 2 // channel #0
          this.$notify({ color: 'error', message: 'Invalid sampling frequency cascade.' })
        }
      }
    },

    handleDeviceFormInput (ev) {
      if (ev.sensor === null) {
        ev.sensor = undefined
      }
      if (ev.digitizer === null) {
        ev.digitizer = undefined
      }
      this.deviceValues = ev
      // if (this.channelValues.length > 0) {
      //   if (this.validateDevices()) {
      //     this.updateChannelsWithNewChain()
      //   }
      // }
    }

  }
}
</script>
